/* eslint-disable */
module.exports = {
  regexpRegisterNum: /^[а-өА-ӨЁ.-]{2}[0-9]{8}$/,
  regexpName: /[а-өА-ӨЁ.-\s]$/,
  regexpMobile: /^(99|95|94|85|88|89|86|80|96|91|90|92|98|93|97|83|77|70|75|78)\d{2}-\d{4}$/,
  regexpEmail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  regexpNumber: /[0-9]/i,
  regexpSmsText: /^[a-zA-Z0-9~!@#$%^&*()`\[\]{};':,./<>?| ]*$/i,
  regexpAscii: /[\x00-\x7F]$/
}
